import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type UserRole = 'DRIVER' | 'DISPATCHER' | 'MANAGER' | 'ADMIN' | 'SUPERADMIN'

export interface LogisticsGroupBrief {
  id: string
  group_code: string
  group_name: string
  unit_of_measure: 'METRIC' | 'IMPERIAL'
  currency: string
}

interface AuthState {
  token: string | null
  role: UserRole | null
  driverName: string | null
  accountId: string | null
  accountName: string | null
  accountSlug: string | null
  logisticsGroups: LogisticsGroupBrief[]
  isAuthenticated: boolean
  setAuth: (token: string, role: UserRole, driverName: string, accountId?: string | null, accountName?: string | null, accountSlug?: string | null, logisticsGroups?: LogisticsGroupBrief[]) => void
  clearAuth: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      role: null,
      driverName: null,
      accountId: null,
      accountName: null,
      accountSlug: null,
      logisticsGroups: [],
      isAuthenticated: false,

      setAuth: (token, role, driverName, accountId = null, accountName = null, accountSlug = null, logisticsGroups = []) =>
        set({ token, role, driverName, accountId, accountName, accountSlug, logisticsGroups, isAuthenticated: true }),

      clearAuth: () =>
        set({ token: null, role: null, driverName: null, accountId: null, accountName: null, accountSlug: null, logisticsGroups: [], isAuthenticated: false }),
    }),
    {
      name: 'fleet-auth',
      partialize: (state) => ({
        token: state.token,
        role: state.role,
        driverName: state.driverName,
        accountId: state.accountId,
        accountName: state.accountName,
        accountSlug: state.accountSlug,
        logisticsGroups: state.logisticsGroups,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
)
